import EbzMenu from './EbzMenu';

export default EbzMenu;
